import { render } from "./QuizPopup.vue?vue&type=template&id=1abe30df&scoped=true"
import script from "./QuizPopup.vue?vue&type=script&lang=js"
export * from "./QuizPopup.vue?vue&type=script&lang=js"

import "./QuizPopup.vue?vue&type=style&index=0&id=1abe30df&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abe30df"]])

export default __exports__